import styles from "./Background.module.css";

import background from "../../../media/Home/homeBanner.jpg";

const BackgroundHome = () => {
    return(
        <article
        className={styles.article}
        style={{ backgroundImage:  `url(${background})` }}>
            <h1 className={styles.header}>Theta Tau at BU</h1>
            <h4 className={styles.headersmtxt}>Boston University's only professional engineering fraternity</h4>
        </article>
    );
};

export default BackgroundHome;